import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography/Typography'

const styles = theme => ({
  footer: {
    height: 60,
    marginTop: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: '1px solid #eef5fb',
    '@media print': {
      display: 'none'
    }
  },
  progress: {
    color: theme.palette.secondary.main
  }
})

const copyright = `${new Date().getFullYear()} IPD Analytics, LLC`

class FooterComponent extends React.PureComponent {
  render () {
    const { classes } = this.props

    return (
      <div className={classes.footer}>
        <Typography variant='body2'>&copy; {copyright}</Typography>
      </div>
    )
  }
}

FooterComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(FooterComponent)
